import React, { useState } from 'react';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import { useEventCallback } from '../../helpers/hooks';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ClearIcon from '@mui/icons-material/Clear';

const useStyles = makeStyles(theme => {
  const formControl = {
    flex: '1 0 auto',
    width: '150px',
    marginRight: theme.spacing(2),
  };
  return {
    container: {
      display: 'flex',
      margin: theme.spacing(0.5),
      marginLeft: theme.spacing(2),
    },
    datePicker: {
      ...formControl,
      width: '140px',
    },
    airportSelect: {
      ...formControl,
    },
    outboundAirportSelect: {
      ...formControl,
    },
    airlineSelect: {
      ...formControl,
      width: '120px',
    },
    clearButton: {
      alignSelf: 'flex-end',
    },
  };
});

const Filters = ({
  airlines,
  airports,
  inboundAirports,
  outboundAirports,
  filters,
  onAirlinesChange,
  onAirportsChange,
  onFiltersClear,
  onInboundAirportsChange,
  onOutboundAirportsChange,
  onYearMonthChange,
}) => {
  const [date, setDate] = useState(moment());
  const classes = useStyles();

  const handleYearMonthChange = useEventCallback(date => {
    setDate(date);
    onYearMonthChange(date);
  }, []);

  const handleAirlinesChange = useEventCallback(event => {
    onAirlinesChange(event.target.value);
  });

  const handleAirportsChange = useEventCallback(event => {
    onAirportsChange(event.target.value);
  });

  const handleInboundAirportsChange = useEventCallback(event => {
    onInboundAirportsChange(event.target.value);
  });

  const handleOutboundAirportsChange = useEventCallback(event => {
    onOutboundAirportsChange(event.target.value);
  });

  return (
    <div className={classes.container}>
      <DatePicker
        className={classes.datePicker}
        openTo="month"
        views={['year', 'month']}
        value={date}
        label={'Year and Month'}
        slotProps={{ field: { variant: 'standard' } }}
        onChange={handleYearMonthChange}
      />
      <FormControl variant="standard" className={classes.airlineSelect}>
        <InputLabel>Airlines</InputLabel>
        <Select
          variant="standard"
          value={filters.airlines}
          multiple
          onChange={handleAirlinesChange}
        >
          {airlines.map(airline => (
            <MenuItem key={airline} value={airline}>
              {airline}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="standard" className={classes.airportSelect}>
        <InputLabel>Arriving from</InputLabel>
        <Select
          variant="standard"
          value={filters.inboundAirports}
          multiple
          onChange={handleInboundAirportsChange}
        >
          {inboundAirports.map(airport => (
            <MenuItem key={airport} value={airport}>
              {airport}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="standard" className={classes.airportSelect}>
        <InputLabel>Station airports</InputLabel>
        <Select
          variant="standard"
          value={filters.airports}
          multiple
          onChange={handleAirportsChange}
        >
          {airports.map(airport => (
            <MenuItem key={airport._id} value={airport.name}>
              {airport.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="standard" className={classes.outboundAirportSelect}>
        <InputLabel>Departing to</InputLabel>
        <Select
          variant="standard"
          value={filters.outboundAirports}
          multiple
          onChange={handleOutboundAirportsChange}
        >
          {outboundAirports.map(airport => (
            <MenuItem key={airport} value={airport}>
              {airport}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        className={classes.clearButton}
        startIcon={<ClearIcon />}
        variant="outlined"
        size="small"
        onClick={onFiltersClear}
      >
        Clear
      </Button>
    </div>
  );
};

export default React.memo(Filters);
